import axios from 'axios';
import { updateUrlByParams } from '../utils/url';

const userApiClient = axios.create({
  baseURL: payload.services.userservice.url,
});

const searchApiClient = axios.create({
  baseURL: payload.services.searchservice.url,
  headers: {
    'request-region': payload.generic.requestRegion
  }
});

export default {
  async search(params, token = null, data = {}) {
    const { urlParams } = updateUrlByParams(params);

    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    return (await searchApiClient.post(`/api/v1/formulation/search${urlParams}`, data, config)).data;
  },

  async loadMore(from, token = null) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    return (await searchApiClient.post(`/api/v1/formulation/search${location.search}`, { from }, config)).data;
  },

  async toggleFavorite(id, token) {
    return (await userApiClient.put(`/api/v1/formulation-repository/formulation/${id}/favorite`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })).data;
  },

  async getSuggestionsByProduct(productId, industry = null, token = null) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    let url = `/api/v1/formulation/by-ingredient/${productId}`;

    if (industry) {
      url += `?i=${industry}`;
    }

    return (await searchApiClient.get(url, config)).data;
  }
};
